import {Component, EventEmitter, Input, Output} from '@angular/core';
import { ProjectService } from '../project/project.service';
import { Client } from '../model/client';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Device} from '../model/device';

/*
TODO : This component is void. It is unused. Remove upon confirmation
 */
@Component({

    selector: 'registerDevice',

    template: `<div class="modal" [style.display]="!hide ? 'inline' : 'none'" >
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <!-- header-->
                <div class="modal-header">
                    <h4 class="modal-title"><span><img alt="icon" class="appWindow" src="../../assets/images/touchscreen.png"></span></h4>
                    <h4>Register Device</h4>
                    <h4 class="closeBtnH4"><button (click)="toggleDialog();" class="btn btn-outline-danger my-2 my-sm-0 closeBtnDiv" data-dismiss="modal" aria-label="Close">
                        <span class="closeX" aria-hidden="true"><img class="closeIcon" alt="closeBtn" src="../../assets/images/closeBtn.png"></span>
                    </button></h4>
                </div>
                <div class="modalBodyContainer">
            <form accept-charset="UTF-8" name="newClientForm" (ngSubmit)="newClientForm.form.valid && registerDevice() " #newClientForm="ngForm">
                <div class="modal-body">
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label>Name</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" placeholder="Client Name" name="deviceName" class="form-control" [(ngModel)]="_device.name" #deviceName="ngModel"
                                required />
                            <div *ngIf="deviceName.errors && (deviceName.dirty || deviceName.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!deviceName.errors.required">
                                    Name is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="margin-top:20px;">
                        <div class="col-md-4">
                            <label> MAC Address </label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" placeholder="mac address eg:24235:6464" name="macAddress" class="form-control" [(ngModel)]="_device.macAddress" #macAddress="ngModel" required />
                            <div *ngIf="macAddress.errors && (macAddress.dirty || macAddress.touched)"
                                class="alert alert-danger">
                                <div [hidden]="!macAddress.errors.required">
                                     Mac address is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- footer-->
                <div class="modal-footer ">
                    <button class="btn btn-primary clickable hand" id="submit" type="submit">Register</button>
                </div>
            </form>
                </div>
        </div>
    </div>
</div>`,
    styles:[`

        .appWindow{height:25px;}

        .modal-dialog {
            width:30%;
            margin:  auto;
        }
        .modal-header{
            background-color:dodgerblue;
            color:antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }
        .modal-content{
            border-top-right-radius: 18px;
            border-top-left-radius: 18px;
        }
        .closeX{color:white;size:25px;}
        .btn-danger{background-color: #d6462e;border-style: solid;border-color: white;border-width:2px;}
        .btn-danger:hover{background-color: #FF2400;}

        /*new css*/


        .modal-title{margin-top: -5px;}
        .closeBtnH4{margin-top:-5px;margin-right: -8px;}
        .appWindow {
            height: 35px;
        }
        .clientRow{background-color: #D0DFFE;}

        .led{width:22px;}

        .tableHeader{ background-image: url("../../assets/images/blueBack.jpg");}
        th{color:#ffffff;text-align: center;}

        .modalBodyContainer{
            padding-left: 3px;
            padding-right: 3px;
        }

        .modal-footer{background-color: #ECE8E5;border-top: groove;}
        .modal-body {
            width: 100%;
            padding-right: 10px;
            padding-left: 10px;
            overflow-y: auto;
            background-color: #ECE8E5;
        }
        .modal-body thead {
            position: sticky;
            top:0;
        }
        ::-webkit-scrollbar {
            width: 14px;
            height: 5px;
            background-color: #F5F3F0;
        }
        ::-webkit-scrollbar-thumb {
            height: 6px;
            border: 4px solid rgba(0, 0, 0, 0);
            background-clip: padding-box;
            -webkit-border-radius: 7px;
            background-color:#BACEFF;
            -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
        }
        ::-webkit-scrollbar-button {
            width: 14px;
            height: 14px;
            display: none;
        }
        ::-webkit-scrollbar-corner {
            background-color: transparent;
        }

        .modal-dialog {
            margin: 50px auto auto;
            background-color: #0064FE;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-header {
            height:56px;
        //background-color: #0064FE;
            background-image: url("../../assets/images/headerBack.jpg");
            color: antiquewhite;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
        }

        .modal-content {
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            background-color: #0064FE;
            padding-bottom: 3px;
        }

        .closeX {
            color: white;
            size: 25px;
        }

        .btn-outline-danger {
            background-color: #d6462e;
            border-style: solid;
            border-color: white;
            border-width: 2px;
            padding: 0;
        }

        /* .btn-outline-danger:hover {
             width: 32px;
             background-image: url("../../../assets/images/closeBtnHovered.png");
         }*/

        .closeIcon:hover{ width: 32px;background-image: url("../../assets/images/closeBtnHovered.png");}

        .closeIcon{ width: 32px;background-image: url("../../assets/images/closeBtn.png");}
    `]

})
export class RegisterDeviceComponent {

    private hide = true;
    private _device: Device = new Device();
    @Output() newDevice: EventEmitter<any> = new EventEmitter();
    private newClientForm:FormGroup;
    private deviceRegistered=false;
    private errorCreatingClient =  false;
    constructor(private _projectService: ProjectService) {
        this.newClientForm = new FormGroup({
            'deviceName':new FormControl(this._device.name,[Validators.required]),
            'macAddress':new FormControl(this._device.macAddress,[Validators.required]),
        });
    }

    registerDevice() {
        this._projectService.registerADevice(this._device)
            .subscribe(data => {
                    console.log(data);
                    this.deviceRegistered=true;
                    this.newDevice.emit(data);
                },
                error => {console.log('Error registering a device');this.errorCreatingClient=true;this.newDevice.emit('An error occurred while registering device code:'+350+'\n Make sure the device is not already registered.');});
        this.toggleDialog();
    }


    toggleDialog() {
        this.newClientForm.reset();
        this._device = new Device();
        this.hide = !this.hide;
    }

    onClose() {
        this.errorCreatingClient=false;
        this.deviceRegistered=false;
    }
}
